// extracted by mini-css-extract-plugin
module.exports = {"container":"JoinButton__container--26N","wide":"JoinButton__wide--3Bo","join":"JoinButton__join--3m-"};